import { useEditorStore } from "../../state/editorStore";

/**
 * Object-tab transform target: main subject OR the selected upload image layer.
 * Each upload keeps its own flip/rotation independently.
 */
export function useActiveSubjectTransform() {
  const selectedLayerId = useEditorStore((s) => s.selectedLayerId);
  const object = useEditorStore((s) => s.object);
  const layers = useEditorStore((s) => s.layers);
  const updateObject = useEditorStore((s) => s.updateObject);
  const updateImageLayer = useEditorStore((s) => s.updateImageLayer);

  const imageLayer =
    selectedLayerId &&
    selectedLayerId !== "object" &&
    selectedLayerId !== "background"
      ? layers.find((l) => l.id === selectedLayerId && l.type === "image")
      : null;

  if (imageLayer) {
    return {
      target: "image",
      layerId: imageLayer.id,
      flipH: Boolean(imageLayer.flipH),
      flipV: Boolean(imageLayer.flipV),
      rotation: Number(imageLayer.rotation) || 0,
      setFlipH: (value, options) =>
        updateImageLayer(imageLayer.id, { flipH: Boolean(value) }, options),
      setFlipV: (value, options) =>
        updateImageLayer(imageLayer.id, { flipV: Boolean(value) }, options),
      resetFlip: (options) =>
        updateImageLayer(
          imageLayer.id,
          { flipH: false, flipV: false },
          options
        ),
      setRotation: (value, options) =>
        updateImageLayer(
          imageLayer.id,
          { rotation: Number(value) || 0 },
          options
        ),
    };
  }

  return {
    target: "object",
    layerId: "object",
    flipH: Boolean(object.flipH),
    flipV: Boolean(object.flipV),
    rotation: Number(object.rotation) || 0,
    setFlipH: (value, options) => updateObject("flipH", Boolean(value), options),
    setFlipV: (value, options) => updateObject("flipV", Boolean(value), options),
    resetFlip: (options) => {
      updateObject("flipH", false, options);
      updateObject("flipV", false, { recordHistory: false });
    },
    setRotation: (value, options) =>
      updateObject("rotation", Number(value) || 0, options),
  };
}
